import ROUTES from '../routes';
import Corporate from '../hoc/corporate';
import CorporateList from '../hoc/corporate/list';
import CreateCorporateCustomer from '../hoc/corporate/create-form';
import CorporateCustomerInformation from '../hoc/corporate/information';
import CorporateCustomerOverview from '../hoc/corporate/overview';
import CustomerStatementsTransactions from '../hoc/common/statements/transactions';
import CustomerStatementsCards from '../hoc/common/statements/cards';
import CorporateCustomerCompanyOfficial from '../hoc/corporate/overview/parts/overview-company-official-panel';
import ProblemGLTransaction from '../hoc/common/problem-transactions/gl';
import AmlStatementsTransactions from '../hoc/common/statements/aml-transactions';
import ProblemInternalTransaction from '../hoc/common/problem-transactions/internal';
import ProblemInternalGeneralContent from '../hoc/common/problem-transactions/internal/parts/problem-internal-general';
import ProblemInternalAmlContent from '../hoc/common/problem-transactions/internal/parts/problem-internal-aml';
import ProblemInternalLogContent from '../hoc/common/problem-transactions/internal/parts/problem-internal-log';
import ProblemInternalDocumentsContent from '../hoc/common/problem-transactions/internal/parts/problem-internal-transaction-documents';
import ProblemInternalChatsContent from '../hoc/common/problem-transactions/internal/parts/problem-internal-transaction-chats';
import ProblemIncomingTransaction from '../hoc/common/problem-transactions/incoming';
import ProblemIncomingGeneralContent from '../hoc/common/problem-transactions/incoming/parts/problem-incoming-general';
import ProblemIncomingOrderContent from '../hoc/common/problem-transactions/incoming/parts/problem-incoming-order';
import ProblemIncomingAmlContent from '../hoc/common/problem-transactions/incoming/parts/problem-incoming-aml';
import ProblemIncomingLogContent from '../hoc/common/problem-transactions/incoming/parts/problem-incoming-log';
import ProblemIncomingChangeLogContent from '../hoc/common/problem-transactions/incoming/parts/problem-incoming-change-log';
import ProblemIncomingDocumentsContent from '../hoc/common/problem-transactions/incoming/parts/problem-incoming-transaction-documents';
import ProblemIncomingChatsContent from '../hoc/common/problem-transactions/incoming/parts/problem-incoming-transaction-chats';
import ProblemOutgoingTransaction from '../hoc/common/problem-transactions/outgoing';
import ProblemOutgoingGeneralContent from '../hoc/common/problem-transactions/outgoing/parts/problem-outgoing-general';
import ProblemOutgoingOrderContent from '../hoc/common/problem-transactions/outgoing/parts/problem-outgoing-order';
import ProblemOutgoingAmlContent from '../hoc/common/problem-transactions/outgoing/parts/problem-outgoing-aml';
import ProblemOutgoingLogContent from '../hoc/common/problem-transactions/outgoing/parts/problem-outgoing-log';
import ProblemOutgoingChangeLogContent from '../hoc/common/problem-transactions/outgoing/parts/problem-outgoing-change-log';
import ProblemOutgoingDocumentsContent from '../hoc/common/problem-transactions/outgoing/parts/problem-outgoing-transaction-documents';
import ProblemOutgoingChatsContent from '../hoc/common/problem-transactions/outgoing/parts/problem-outgoing-transaction-chats';
import ProblemExchangeTransaction from '../hoc/common/problem-transactions/exchange';
import ProblemExchangeGeneralContent from '../hoc/common/problem-transactions/exchange/parts/problem-exchange-transaction-general';
import ProblemExchangeChats from '../hoc/common/problem-transactions/exchange/parts/problem-exchange-transaction-chats';
import ProblemExchangeLog from '../hoc/common/problem-transactions/exchange/parts/problem-exchange-transaction-log';
import ProblemExchangeChangeLog from '../hoc/common/problem-transactions/exchange/parts/problem-exchange-transaction-change-log';
import ProblemNostroTransaction from '../hoc/common/problem-transactions/nostro';
import ProblemNostroGeneralContent from '../hoc/common/problem-transactions/nostro/parts/problem-nostro-transaction-general';
import ProblemNostroLog from '../hoc/common/problem-transactions/nostro/parts/problem-nostro-transaction-log';
import ProblemNostroChangeLog from '../hoc/common/problem-transactions/nostro/parts/problem-nostro-transaction-change-log';
import CardTransaction from '../hoc/common/statements/card-transaction';
import CustomerStatistic from '../hoc/common/statistics';
import CustomerCards from '../hoc/common/cards';
import CustomerDocuments from '../hoc/common/documents';
import CustomerDocumentCreate from '../hoc/common/documents/parts/create';
import CustomerDocumentInfo from '../hoc/common/documents/parts/info';
import CustomerTariffs from '../hoc/common/tariff';
import CustomerCreateFee from '../hoc/common/tariff/fee-form';
import CustomerTransactionFromFee from '../hoc/common/tariff/transaction-from-fee';
import SelectCompanyOfficial from '../hoc/corporate/overview/parts/select-company-official';
import CreateCompanyOfficial from '../hoc/corporate/overview/parts/create-company-official';
import CustomerOrderCard from '../hoc/common/cards/order';
import IncomingTransactionWarnings from '../hoc/common/problem-transactions/incoming/parts/problem-incoming-transaction-warnings';
import OutgoingTransactionWarnings from '../hoc/common/problem-transactions/outgoing/parts/problem-outgoing-transaction-warnings';
import InternalTransactionWarnings from '../hoc/common/problem-transactions/internal/parts/problem-internal-transaction-warnings';
import InternalTransactionChangeLogs from '../hoc/common/problem-transactions/internal/parts/problem-internal-transactions-change-log';
import StatementGLTransaction from '../hoc/common/statement-gl-transaction';
import CustomerAgreement from '../hoc/common/documents/parts/agreement';

import Beneficiaries from '../hoc/common/beneficiaries';
import Beneficiary from '../hoc/common/beneficiaries/beneficiary';
import BeneficiaryContract from '../hoc/common/beneficiaries/contract';
import ExternalAccounts from '../hoc/common/external-accounts';
import CustomersExternalAccount from '../hoc/common/external-accounts/parts/account-form';
import ExhcangeTransactionComments from '../hoc/common/problem-transactions/exchange/parts/problem-exchange-transaction-comments';
import NostroTransactionComments from '../hoc/common/problem-transactions/nostro/parts/problem-nostro-transcation-comments';
import InternalTransactionComments from '../hoc/common/problem-transactions/internal/parts/problem-internal-transaction-comments';
import IncomingTransactionComments from '../hoc/common/problem-transactions/incoming/parts/problem-incoming-transaction-comments';
import OutgoingTransactionComments from '../hoc/common/problem-transactions/outgoing/parts/problem-outgoing-transacation-comments';
import CustomerAccounts from '../hoc/common/accounts';
import CustomerExternalAccounts from '../hoc/common/external-accounts/accounts';
import CustomerLinkedClients from '../hoc/common/linked-clients';
import LinkCustomerForm from '../hoc/common/linked-clients/form';
import CustomerAML from '../hoc/common/aml';

import { OrganizationType } from '../hoc/common/types';

const CorporateCustomers = {
  path: ROUTES.CUSTOMERS_CORPORATE,
  element: <Corporate />,
  children: [
    {
      path: ROUTES.CUSTOMERS_CORPORATE_LIST,
      element: <CorporateList />,
      children: [
        {
          path: ROUTES.CUSTOMERS_CORPORATE_CREATE,
          element: <CreateCorporateCustomer />,
        },
      ],
    },
    {
      path: ROUTES.CUSTOMERS_CORPORATE_PAGE,
      element: <CorporateCustomerInformation />,
      children: [
        {
          path: ROUTES.CUSTOMERS_CORPORATE_OVERVIEW,
          element: <CorporateCustomerOverview />,
          children: [
            {
              path: ROUTES.CUSTOMERS_CORPORATE_OVERVIEW_TRANSACTIONS,
              element: (
                <CustomerStatementsTransactions
                  customerType={OrganizationType.CORPORATE}
                />
              ),
              children: [
                {
                  path: ROUTES.CUSTOMERS_CORPORATE_OVERVIEW_COMPANY_OFFICIAL,
                  element: <CorporateCustomerCompanyOfficial />,
                },
                {
                  path: ROUTES.CUSTOMERS_CORPORATE_OVERVIEW_SELECT_COMPANY_OFFICIAL,
                  element: <SelectCompanyOfficial />,
                },
                {
                  path: ROUTES.CUSTOMERS_CORPORATE_OVERVIEW_ADD_COMPANY_OFFICIAL,
                  element: <CreateCompanyOfficial />,
                },
                {
                  path: ROUTES.CUSTOMERS_CORPORATE_OVERVIEW_TRANSACTIONS_GL,
                  element: (
                    <StatementGLTransaction
                      customerType={OrganizationType.CORPORATE}
                    />
                  ),
                },
              ],
            },
            {
              path: ROUTES.CUSTOMERS_CORPORATE_OVERVIEW_CARDS,
              element: (
                <CustomerStatementsCards
                  customerType={OrganizationType.CORPORATE}
                  page="overview"
                />
              ),
              children: [
                {
                  path: ROUTES.CUSTOMERS_CORPORATE_OVERVIEW_CARDS_COMPANY_OFFICIAL,
                  element: <CorporateCustomerCompanyOfficial />,
                },
                {
                  path: ROUTES.CUSTOMERS_CORPORATE_OVERVIEW_CARDS_SELECT_COMPANY_OFFICIAL,
                  element: <SelectCompanyOfficial />,
                },
                {
                  path: ROUTES.CUSTOMERS_CORPORATE_OVERVIEW_CARDS_ADD_COMPANY_OFFICIAL,
                  element: <CreateCompanyOfficial />,
                },
              ],
            },
          ],
        },
        {
          path: ROUTES.CUSTOMERS_CORPORATE_ACCOUNTS,
          element: <CustomerAccounts type={OrganizationType.CORPORATE} />,
          children: [
            {
              path: ROUTES.CUSTOMERS_CORPORATE_ACCOUNTS_TRANSACTIONS,
              element: (
                <CustomerStatementsTransactions
                  customerType={OrganizationType.CORPORATE}
                />
              ),
              children: [
                {
                  path: ROUTES.CUSTOMERS_CORPORATE_ACCOUNTS_TRANSACTION_GL,
                  element: (
                    <StatementGLTransaction
                      customerType={OrganizationType.CORPORATE}
                      accountsPage
                    />
                  ),
                },
              ],
            },
            {
              path: ROUTES.CUSTOMERS_CORPORATE_ACCOUNTS_CARDS,
              element: (
                <CustomerStatementsCards
                  customerType={OrganizationType.CORPORATE}
                  page="accounts"
                />
              ),
              children: [
                {
                  path: ROUTES.CUSTOMERS_CORPORATE_ACCOUNTS_CARD_TRANSACTION,
                  element: (
                    <CardTransaction
                      backPath={ROUTES.CUSTOMERS_CORPORATE_ACCOUNTS_CARDS}
                    />
                  ),
                },
              ],
            },
          ],
        },
        {
          path: ROUTES.CUSTOMERS_CORPORATE_EXTERNAL_ACCOUNTS,
          element: <ExternalAccounts type={OrganizationType.CORPORATE} />,
          children: [
            {
              path: ROUTES.CUSTOMERS_CORPORATE_EXTERNAL_ACCOUNTS_LIST,
              element: (
                <CustomerExternalAccounts type={OrganizationType.CORPORATE} />
              ),
              children: [
                {
                  path: ROUTES.CUSTOMERS_CORPORATE_EXTERNAL_ACCOUNTS_CREATE,
                  element: (
                    <CustomersExternalAccount
                      type={OrganizationType.CORPORATE}
                    />
                  ),
                },

                {
                  path: ROUTES.CUSTOMERS_CORPORATE_EXTERNAL_ACCOUNTS_ITEM,
                  element: (
                    <CustomersExternalAccount
                      type={OrganizationType.CORPORATE}
                    />
                  ),
                },
              ],
            },
            {
              path: ROUTES.CUSTOMERS_CORPORATE_EXTERNAL_LINKED_CLIENTS,
              element: (
                <CustomerLinkedClients type={OrganizationType.CORPORATE} />
              ),
              children: [
                {
                  path: ROUTES.CUSTOMERS_CORPORATE_EXTERNAL_LINKED_CLIENTS_CREATE,
                  element: (
                    <LinkCustomerForm type={OrganizationType.CORPORATE} />
                  ),
                },
              ],
            },
          ],
        },
        {
          path: ROUTES.CUSTOMERS_CORPORATE_AML,
          element: <CustomerAML type={OrganizationType.CORPORATE} />,
          children: [
            {
              path: ROUTES.CUSTOMERS_CORPORATE_AML_TRANSACTIONS,
              element: (
                <AmlStatementsTransactions
                  customerType={OrganizationType.CORPORATE}
                />
              ),
              children: [
                {
                  path: ROUTES.CUSTOMERS_CORPORATE_AML_TRANSACTION_GL,
                  element: (
                    <ProblemGLTransaction
                      backPath={ROUTES.CUSTOMERS_CORPORATE_AML_TRANSACTIONS}
                    />
                  ),
                },
                {
                  path: ROUTES.CUSTOMERS_CORPORATE_AML_TRANSACTION_EXCHANGE,
                  element: (
                    <ProblemExchangeTransaction
                      backPath={ROUTES.CUSTOMERS_CORPORATE_AML_TRANSACTIONS}
                      matchPath={
                        ROUTES.CUSTOMERS_CORPORATE_AML_TRANSACTION_EXCHANGE
                      }
                      generalPath={
                        ROUTES.CUSTOMERS_CORPORATE_AML_TRANSACTION_EXCHANGE_GENERAL
                      }
                      logPath={
                        ROUTES.CUSTOMERS_CORPORATE_AML_TRANSACTION_EXCHANGE_LOG
                      }
                      changeLogPath={
                        ROUTES.CUSTOMERS_CORPORATE_AML_TRANSACTION_EXCHANGE_CHANGE_LOG
                      }
                      chatPath={
                        ROUTES.CUSTOMERS_CORPORATE_AML_TRANSACTION_EXCHANGE_CHATS
                      }
                      commentsPath={
                        ROUTES.CUSTOMERS_CORPORATE_AML_TRANSACTION_EXCHANGE_CHATS
                      }
                    />
                  ),
                  children: [
                    {
                      path: ROUTES.CUSTOMERS_CORPORATE_AML_TRANSACTION_EXCHANGE,
                      element: <ProblemExchangeGeneralContent />,
                    },
                    {
                      path: ROUTES.CUSTOMERS_CORPORATE_AML_TRANSACTION_EXCHANGE_LOG,
                      element: <ProblemExchangeLog />,
                    },
                    {
                      path: ROUTES.CUSTOMERS_CORPORATE_AML_TRANSACTION_EXCHANGE_CHANGE_LOG,
                      element: <ProblemExchangeChangeLog />,
                    },
                    {
                      path: ROUTES.CUSTOMERS_CORPORATE_AML_TRANSACTION_EXCHANGE_CHATS,
                      element: <ProblemExchangeChats />,
                    },
                    {
                      path: ROUTES.CUSTOMERS_CORPORATE_AML_TRANSACTION_EXCHANGE_COMMENTS,
                      element: <ExhcangeTransactionComments />,
                    },
                  ],
                },
                {
                  path: ROUTES.CUSTOMERS_CORPORATE_AML_TRANSACTION_NOSTRO,
                  element: (
                    <ProblemNostroTransaction
                      backPath={ROUTES.CUSTOMERS_CORPORATE_AML_TRANSACTIONS}
                      matchPath={
                        ROUTES.CUSTOMERS_CORPORATE_AML_TRANSACTION_NOSTRO
                      }
                      generalPath={
                        ROUTES.CUSTOMERS_CORPORATE_AML_TRANSACTION_NOSTRO_GENERAL
                      }
                      logPath={
                        ROUTES.CUSTOMERS_CORPORATE_AML_TRANSACTION_NOSTRO_LOG
                      }
                      changeLogPath={
                        ROUTES.CUSTOMERS_CORPORATE_AML_TRANSACTION_NOSTRO_CHANGE_LOG
                      }
                      commentsPath={
                        ROUTES.CUSTOMERS_CORPORATE_AML_TRANSACTION_NOSTRO_COMMENTS
                      }
                    />
                  ),
                  children: [
                    {
                      path: ROUTES.CUSTOMERS_CORPORATE_AML_TRANSACTION_NOSTRO,
                      element: <ProblemNostroGeneralContent />,
                    },
                    {
                      path: ROUTES.CUSTOMERS_CORPORATE_AML_TRANSACTION_NOSTRO_LOG,
                      element: <ProblemNostroLog />,
                    },
                    {
                      path: ROUTES.CUSTOMERS_CORPORATE_AML_TRANSACTION_NOSTRO_CHANGE_LOG,
                      element: <ProblemNostroChangeLog />,
                    },
                    {
                      path: ROUTES.CUSTOMERS_CORPORATE_AML_TRANSACTION_NOSTRO_COMMENTS,
                      element: <NostroTransactionComments />,
                    },
                  ],
                },
                {
                  path: ROUTES.CUSTOMERS_CORPORATE_AML_TRANSACTION_INTERNAL,
                  element: (
                    <ProblemInternalTransaction
                      matchPath={
                        ROUTES.CUSTOMERS_CORPORATE_AML_TRANSACTION_INTERNAL
                      }
                      warningPath={
                        ROUTES.CUSTOMERS_CORPORATE_AML_TRANSACTION_INTERNAL_WARNING
                      }
                      generalPath={
                        ROUTES.CUSTOMERS_CORPORATE_AML_TRANSACTION_INTERNAL_GENERAL
                      }
                      amlPath={
                        ROUTES.CUSTOMERS_CORPORATE_AML_TRANSACTION_INTERNAL_AML
                      }
                      logPath={
                        ROUTES.CUSTOMERS_CORPORATE_AML_TRANSACTION_INTERNAL_LOG
                      }
                      changeLogPath={
                        ROUTES.CUSTOMERS_CORPORATE_AML_TRANSACTION_INTERNAL_CHANGE_LOG
                      }
                      backPath={ROUTES.CUSTOMERS_CORPORATE_AML_TRANSACTIONS}
                      chatPath={
                        ROUTES.CUSTOMERS_CORPORATE_AML_TRANSACTION_INTERNAL_CHATS
                      }
                      documentPath={
                        ROUTES.CUSTOMERS_CORPORATE_AML_TRANSACTION_INTERNAL_DOCUMENTS
                      }
                      commentsPath={
                        ROUTES.CUSTOMERS_CORPORATE_AML_TRANSACTION_INTERNAL_COMMENTS
                      }
                    />
                  ),
                  children: [
                    {
                      path: ROUTES.CUSTOMERS_CORPORATE_AML_TRANSACTION_INTERNAL_GENERAL,
                      element: <ProblemInternalGeneralContent />,
                    },
                    {
                      path: ROUTES.CUSTOMERS_CORPORATE_AML_TRANSACTION_INTERNAL_AML,
                      element: <ProblemInternalAmlContent />,
                    },
                    {
                      path: ROUTES.CUSTOMERS_CORPORATE_AML_TRANSACTION_INTERNAL_LOG,
                      element: <ProblemInternalLogContent />,
                    },
                    {
                      path: ROUTES.CUSTOMERS_CORPORATE_AML_TRANSACTION_INTERNAL_WARNING,
                      element: <InternalTransactionWarnings />,
                    },
                    {
                      path: ROUTES.CUSTOMERS_CORPORATE_AML_TRANSACTION_INTERNAL_CHANGE_LOG,
                      element: <InternalTransactionChangeLogs />,
                    },
                    {
                      path: ROUTES.CUSTOMERS_CORPORATE_AML_TRANSACTION_INTERNAL_DOCUMENTS,
                      element: <ProblemInternalDocumentsContent />,
                    },
                    {
                      path: ROUTES.CUSTOMERS_CORPORATE_AML_TRANSACTION_INTERNAL_CHATS,
                      element: <ProblemInternalChatsContent />,
                    },
                    {
                      path: ROUTES.CUSTOMERS_CORPORATE_AML_TRANSACTION_INTERNAL_COMMENTS,
                      element: <InternalTransactionComments />,
                    },
                  ],
                },
                {
                  path: ROUTES.CUSTOMERS_CORPORATE_AML_TRANSACTION_INCOMING,
                  element: (
                    <ProblemIncomingTransaction
                      matchPath={
                        ROUTES.CUSTOMERS_CORPORATE_AML_TRANSACTION_INCOMING
                      }
                      backPath={ROUTES.CUSTOMERS_CORPORATE_AML_TRANSACTIONS}
                      generalPath={
                        ROUTES.CUSTOMERS_CORPORATE_AML_TRANSACTION_INCOMING_GENERAL
                      }
                      amlPath={
                        ROUTES.CUSTOMERS_CORPORATE_AML_TRANSACTION_INCOMING_AML
                      }
                      orderPath={
                        ROUTES.CUSTOMERS_CORPORATE_AML_TRANSACTION_INCOMING_ORDER
                      }
                      logPath={
                        ROUTES.CUSTOMERS_CORPORATE_AML_TRANSACTION_INCOMING_LOG
                      }
                      changeLogPath={
                        ROUTES.CUSTOMERS_CORPORATE_AML_TRANSACTION_INCOMING_CHANGE_LOG
                      }
                      warningPath={
                        ROUTES.CUSTOMERS_CORPORATE_AML_TRANSACTION_INCOMING_WARNINGS
                      }
                      documentPath={
                        ROUTES.CUSTOMERS_CORPORATE_AML_TRANSACTION_INCOMING_DOCUMENTS
                      }
                      chatPath={
                        ROUTES.CUSTOMERS_CORPORATE_AML_TRANSACTION_INCOMING_CHATS
                      }
                      commentsPath={
                        ROUTES.CUSTOMERS_CORPORATE_AML_TRANSACTION_INCOMING_COMMENTS
                      }
                    />
                  ),
                  children: [
                    {
                      path: ROUTES.CUSTOMERS_CORPORATE_AML_TRANSACTION_INCOMING_GENERAL,
                      element: <ProblemIncomingGeneralContent />,
                    },
                    {
                      path: ROUTES.CUSTOMERS_CORPORATE_AML_TRANSACTION_INCOMING_ORDER,
                      element: <ProblemIncomingOrderContent />,
                    },
                    {
                      path: ROUTES.CUSTOMERS_CORPORATE_AML_TRANSACTION_INCOMING_AML,
                      element: <ProblemIncomingAmlContent />,
                    },
                    {
                      path: ROUTES.CUSTOMERS_CORPORATE_AML_TRANSACTION_INCOMING_LOG,
                      element: <ProblemIncomingLogContent />,
                    },
                    {
                      path: ROUTES.CUSTOMERS_CORPORATE_AML_TRANSACTION_INCOMING_CHANGE_LOG,
                      element: <ProblemIncomingChangeLogContent />,
                    },
                    {
                      path: ROUTES.CUSTOMERS_CORPORATE_AML_TRANSACTION_INCOMING_WARNINGS,
                      element: <IncomingTransactionWarnings />,
                    },
                    {
                      path: ROUTES.CUSTOMERS_CORPORATE_AML_TRANSACTION_INCOMING_DOCUMENTS,
                      element: <ProblemIncomingDocumentsContent />,
                    },
                    {
                      path: ROUTES.CUSTOMERS_CORPORATE_AML_TRANSACTION_INCOMING_CHATS,
                      element: <ProblemIncomingChatsContent />,
                    },
                    {
                      path: ROUTES.CUSTOMERS_CORPORATE_AML_TRANSACTION_INCOMING_COMMENTS,
                      element: <IncomingTransactionComments />,
                    },
                  ],
                },
                {
                  path: ROUTES.CUSTOMERS_CORPORATE_AML_TRANSACTION_OUTGOING,
                  element: (
                    <ProblemOutgoingTransaction
                      matchPath={
                        ROUTES.CUSTOMERS_CORPORATE_AML_TRANSACTION_OUTGOING
                      }
                      backPath={ROUTES.CUSTOMERS_CORPORATE_AML_TRANSACTIONS}
                      generalPath={
                        ROUTES.CUSTOMERS_CORPORATE_AML_TRANSACTION_OUTGOING_GENERAL
                      }
                      amlPath={
                        ROUTES.CUSTOMERS_CORPORATE_AML_TRANSACTION_OUTGOING_AML
                      }
                      orderPath={
                        ROUTES.CUSTOMERS_CORPORATE_AML_TRANSACTION_OUTGOING_ORDER
                      }
                      logPath={
                        ROUTES.CUSTOMERS_CORPORATE_AML_TRANSACTION_OUTGOING_LOG
                      }
                      changeLogPath={
                        ROUTES.CUSTOMERS_INDIVIDUAL_AML_TRANSACTION_OUTGOING_CHANGE_LOG
                      }
                      warningPath={
                        ROUTES.CUSTOMERS_CORPORATE_AML_TRANSACTION_OUTGOING_WARNINGS
                      }
                      documentPath={
                        ROUTES.CUSTOMERS_CORPORATE_AML_TRANSACTION_OUTGOING_DOCUMENTS
                      }
                      chatPath={
                        ROUTES.CUSTOMERS_CORPORATE_AML_TRANSACTION_OUTGOING_CHATS
                      }
                      commentsPath={
                        ROUTES.CUSTOMERS_CORPORATE_AML_TRANSACTION_OUTGOING_COMMENTS
                      }
                    />
                  ),
                  children: [
                    {
                      path: ROUTES.CUSTOMERS_CORPORATE_AML_TRANSACTION_OUTGOING_GENERAL,
                      element: <ProblemOutgoingGeneralContent />,
                    },
                    {
                      path: ROUTES.CUSTOMERS_CORPORATE_AML_TRANSACTION_OUTGOING_ORDER,
                      element: <ProblemOutgoingOrderContent />,
                    },
                    {
                      path: ROUTES.CUSTOMERS_CORPORATE_AML_TRANSACTION_OUTGOING_AML,
                      element: <ProblemOutgoingAmlContent />,
                    },
                    {
                      path: ROUTES.CUSTOMERS_CORPORATE_AML_TRANSACTION_OUTGOING_LOG,
                      element: <ProblemOutgoingLogContent />,
                    },
                    {
                      path: ROUTES.CUSTOMERS_CORPORATE_AML_TRANSACTION_OUTGOING_CHANGE_LOG,
                      element: <ProblemOutgoingChangeLogContent />,
                    },

                    {
                      path: ROUTES.CUSTOMERS_CORPORATE_AML_TRANSACTION_OUTGOING_WARNINGS,
                      element: <OutgoingTransactionWarnings />,
                    },
                    {
                      path: ROUTES.CUSTOMERS_CORPORATE_AML_TRANSACTION_OUTGOING_DOCUMENTS,
                      element: <ProblemOutgoingDocumentsContent />,
                    },
                    {
                      path: ROUTES.CUSTOMERS_CORPORATE_AML_TRANSACTION_OUTGOING_CHATS,
                      element: <ProblemOutgoingChatsContent />,
                    },
                    {
                      path: ROUTES.CUSTOMERS_CORPORATE_AML_TRANSACTION_OUTGOING_COMMENTS,
                      element: <OutgoingTransactionComments />,
                    },
                  ],
                },
              ],
            },
            {
              path: ROUTES.CUSTOMERS_CORPORATE_AML_CARDS,
              element: (
                <CustomerStatementsCards
                  customerType={OrganizationType.CORPORATE}
                  page="aml"
                />
              ),
              children: [
                {
                  path: ROUTES.CUSTOMERS_CORPORATE_AML_CARD_TRANSACTION,
                  element: (
                    <CardTransaction
                      backPath={ROUTES.CUSTOMERS_CORPORATE_AML_CARDS}
                    />
                  ),
                },
              ],
            },
          ],
        },
        {
          path: ROUTES.CUSTOMERS_CORPORATE_STATISTICS,
          element: (
            <CustomerStatistic customerType={OrganizationType.CORPORATE} />
          ),
        },
        {
          path: ROUTES.CUSTOMERS_CORPORATE_DOCUMENTS,
          element: <CustomerDocuments type={OrganizationType.CORPORATE} />,
          children: [
            {
              path: ROUTES.CUSTOMERS_CORPORATE_AGREEMENT,
              element: (
                <CustomerAgreement customerType={OrganizationType.CORPORATE} />
              ),
            },
            {
              path: ROUTES.CUSTOMERS_CORPORATE_DOCUMENTS_INFO,
              element: (
                <CustomerDocumentInfo
                  customerType={OrganizationType.CORPORATE}
                />
              ),
            },
            {
              path: ROUTES.CUSTOMERS_CORPORATE_DOCUMENTS_ADD,
              element: (
                <CustomerDocumentCreate
                  customerType={OrganizationType.CORPORATE}
                />
              ),
            },
          ],
        },
        {
          path: ROUTES.CUSTOMERS_CORPORATE_CARDS,
          element: <CustomerCards type={OrganizationType.CORPORATE} />,
          children: [
            {
              path: ROUTES.CUSTOMERS_CORPORATE_CARDS_TRANSACTION,
              element: (
                <CardTransaction backPath={ROUTES.CUSTOMERS_CORPORATE_CARDS} />
              ),
            },
            {
              path: ROUTES.CUSTOMERS_CORPORATE_CARDS_ORDER,
              element: <CustomerOrderCard type={OrganizationType.CORPORATE} />,
            },
            {
              path: ROUTES.CUSTOMERS_CORPORATE_CARDS_EDIT,
              element: <CustomerOrderCard type={OrganizationType.CORPORATE} />,
            },
          ],
        },
        {
          path: ROUTES.CUSTOMERS_CORPORATE_TARIFFS,
          element: <CustomerTariffs type={OrganizationType.CORPORATE} />,
          children: [
            {
              path: ROUTES.CUSTOMERS_CORPORATE_TARIFFS_FEE,
              element: <CustomerCreateFee type={OrganizationType.CORPORATE} />,
              children: [
                {
                  path: ROUTES.CUSTOMERS_CORPORATE_TARIFFS_CREATE_TRANSACTION,
                  element: (
                    <CustomerTransactionFromFee
                      type={OrganizationType.CORPORATE}
                    />
                  ),
                },
              ],
            },
          ],
        },
        {
          path: ROUTES.CUSTOMERS_CORPORATE_BENEFICIARIES,
          element: <Beneficiaries type={OrganizationType.CORPORATE} />,
          children: [
            {
              path: ROUTES.CUSTOMERS_CORPORATE_BENEFICIARY,
              element: <Beneficiary type={OrganizationType.CORPORATE} />,
              children: [
                {
                  path: ROUTES.CUSTOMERS_CORPORATE_BENEFICIARY_CONTRACT,
                  element: (
                    <BeneficiaryContract type={OrganizationType.CORPORATE} />
                  ),
                },
              ],
            },
          ],
        },
      ],
    },
  ],
};

export default CorporateCustomers;
